import React from 'react';

import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { observer } from 'mobx-react';
import { BringgMap } from '@bringg-frontend/bringg-map';

import { useStores } from 'bringg-web/recipes';
import useTimeFormat from 'bringg-web/hooks/use-time-format';
import useOrderExplorerStore from '../stores/use-order-explorer-store';

import styles from './orders-map.module.scss';

const OrdersMap = () => {
	const { authStore } = useStores();
	const timeFormat = useTimeFormat();
	const {
		ordersMapStore: { markers, polylines },
		selectedTasksStore: { setSelectedTasks, selectedTasks, clearSelectedTasks }
	} = useOrderExplorerStore();

	const onMarkerClick = (id: number, isCtrlClick: boolean) => {
		const task = getRootEnv().dashboardSdk.sdk.v2.tasks.get(id);
		setSelectedTasks(task, isCtrlClick);
	};

	return (
		<BringgMap
			allowTrafficLayer
			markers={markers || []}
			polylines={polylines}
			timeZone={authStore.merchant.time_zone}
			timeFormat={timeFormat}
			mapElementClassName={styles.ordersMap}
			mapContainerClassName={styles.ordersMapContainer}
			fullscreenControl={false}
			forceRecenterOnAddingMarkers={true}
			onMarkerClick={(id, isCtrlClick) => onMarkerClick(id as number, isCtrlClick)}
			selectedMarkers={selectedTasks.map(({ id }) => id)}
			clearSelectedMarkers={clearSelectedTasks}
		/>
	);
};

export default observer(OrdersMap);
